export const environment = {
  production: true,
  localhost: false,
  apiUrl: '//saraclean.crealab.dev/api',
  apiVersion: 'v1',
  stripePublishableKey: 'pk_live_5QlGv1WZnLUCYBXQIBnXBGfs005GwoGVnK',
}
